import axios from "axios";
const BASE = process.env.REACT_APP_API_BASE || "http://localhost:5000";
export async function getSessions() {
  const r = await axios.get(`${BASE}/api/sessions`);
  return r.data;
}

export async function forceCheckout(sessionId) {
  const r = await axios.post(`${BASE}/api/checkout`, { sessionId });
  return r.data;
}

export async function createCheckin(data) {
  const r = await axios.post(`${BASE}/api/checkin`, data);
  console.log("after createCheckin request 2");
  return r.data;
}

export async function createGuests(data) {
  const r = await axios.post(`${BASE}/api/guests`, data);
  return r.data;
}
